// extracted by css-extract-rspack-plugin
export default {"list":"PEi1N","tab":"Fcuma","label":"L6BSZ","pills":"fImpo","section":"qmLNT","leftSection":"Tc7cO","rightSection":"M1Nc1"};